// extracted by mini-css-extract-plugin
export default {"googleTranslate":"_1fnLsdp7zXu39o0tTS9VJ5"};